import React from 'react';
import SectionTitle from '../common/SectionTitle';
import { useLanguage } from '../../context/LanguageContext';

const PromoThree = ({hasBg}) => {
  const { t } = useLanguage();

  return (
    <>
      <section className={`promo-section ptb-120 ${hasBg?'bg-light':''}`}>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-10 col-lg-6'>
              <SectionTitle
                title={t('promoThree.title')}
                description={t('promoThree.description')}
                centerAlign
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-lg-4'>
              <div
                className='promo-card-wrap promo-border-hover border border-2 bg-white rounded-custom p-5 mb-4 mb-lg-0 mb-md-4'
                data-aos='fade-up'
                data-aos-delay='50'
              >
                <div className='promo-card-info'>
                  <h3 className='display-5 fw-medium mb-4'>{t('promoThree.cards.0.number')}</h3>
                  <h2 className='h5'>{t('promoThree.cards.0.title')}</h2>
                  <p className='mb-0'>
                    {t('promoThree.cards.0.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-4'>
              <div
                className='promo-card-wrap promo-border-hover border border-2 bg-white rounded-custom p-5 mb-4 mb-lg-0 mb-md-4'
                data-aos='fade-up'
                data-aos-delay='100'
              >
                <div className='promo-card-info'>
                  <h3 className='display-5 fw-medium mb-4'>{t('promoThree.cards.1.number')}</h3>
                  <h2 className='h5'>{t('promoThree.cards.1.title')}</h2>
                  <p className='mb-0'>
                    {t('promoThree.cards.1.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-4'>
              <div
                className='promo-card-wrap promo-border-hover border border-2 bg-white rounded-custom p-5 mb-4 mb-lg-0 mb-md-0'
                data-aos='fade-up'
                data-aos-delay='150'
              >
                <div className='promo-card-info'>
                  <h3 className='display-5 fw-medium mb-4'>{t('promoThree.cards.2.number')}</h3>
                  <h2 className='h5'>{t('promoThree.cards.2.title')}</h2>
                  <p className='mb-0'>
                    {t('promoThree.cards.2.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PromoThree;
